import { ItemList } from '../orm'

class SupportList extends ItemList {
    getEntityKey() {
        return "support"
    }
}

export const supportList = new SupportList("support__default")
